import { useTranslation } from 'react-i18next';
import { FlowErrorPanel } from '@/components/pos/FlowErrorPanel';

interface ClientManagerAlertProps {
  /** `customers.client_manager_error` — a Client Manager code (DOCUMENT_EXPIRED, …) or a short reason */
  error: string;
  onRetry: () => void;
  loading?: boolean;
}

/** FR-106: MyID passed, but Client Manager did not accept the customer — the contract cannot open until a retry works. */
export function ClientManagerAlert({ error, onRetry, loading }: ClientManagerAlertProps) {
  const { t } = useTranslation();

  return (
    <div data-testid="client-manager-alert">
      <FlowErrorPanel
        message={t('murabaha_flow.client_manager.error', { code: error })}
        loading={loading}
        onRetry={onRetry}
        retryLabel={t('murabaha_flow.client_manager.retry')}
      />
    </div>
  );
}
